/**
 * @voltxampere/ui — Homemade BC547+LED phototransistor variant (Sprint 43-6, placeholder)
 *
 * Educational placeholder for the classic "remove the BC547's metal
 * cap and let light hit the base junction" homemade phototransistor
 * trick. The variant ships as a regular BC547 NPN; the optical
 * sensitivity is documented but not modelled. Real photoresponse +
 * base-junction illuminance simulation lands Sprint 47+.
 *
 * Reference: Generic BC547B in TO-92 with the metal cap removed,
 * exposing the silicon die. Engine zero-diff invariant honored —
 * canonical `bjt-npn` engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const sensorBc547LedPhoto = {
    id: "bc547-photo",
    nameTr: "BC547 + LED (Ev Yapımı Fototransistör, placeholder)",
    nameEn: "BC547 + LED (Homemade Phototransistor, placeholder)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "BC547+LED",
    schemaType: "bjt-npn",
    defaultParams: {
        Is: 7e-15,
        Bf: 250,
        Br: 10,
        Vaf: 100,
    },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=sensor-bc547-led-photo.js.map